import React, { Component, type ComponentType } from 'react';
import '@atlaskit/css-reset';
import { ProjectContextProvider } from '@atlassian/jira-providers-project-context';
import {
	RedirectToArchivedPage,
	isProjectArchivedCondition,
} from '@atlassian/jira-redirect-archived-project/src/ui/index.tsx';
import { AuthenticationCheck } from '@atlassian/jira-spa-apps-common/src/interceptors/authentication';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { withRouter, type RouteContext } from '@atlassian/react-resource-router';
import OpsgenieSchedule from './view';

export type Props = RouteContext;

// eslint-disable-next-line jira/react/no-class-components
export class OpsgenieScheduleApp extends Component<Props> {
	renderContent = () => (
		<TenantContextSubscriber>
			{({ tenantContext }) =>
				tenantContext && (
					<ProjectContextProvider>
						{(projectContext) => {
							if (isProjectArchivedCondition(projectContext.data)) {
								return <RedirectToArchivedPage />;
							}
							return (
								<>
									{projectContext && (
										<OpsgenieSchedule
											projectContext={projectContext}
											tenantContext={tenantContext}
										/>
									)}
								</>
							);
						}}
					</ProjectContextProvider>
				)
			}
		</TenantContextSubscriber>
	);

	render() {
		return (
			<>
				<MarkProductStart />
				<AuthenticationCheck>{this.renderContent()}</AuthenticationCheck>
			</>
		);
	}
}

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
export default withRouter(OpsgenieScheduleApp) as ComponentType<Record<any, any>>;
